module.exports = __webpack_public_path__ + "img/e_3_25_g.7a2b6995.png";